import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Modal from 'js/components/modal';

const ArchiveModal = (props) => {
  const { className, mounted, onDismiss, onConfirm, isActive } = props;
  const { t } = useTranslation();
  return (
    <Modal
      className={classnames('archive-modal', className)}
      onClickCancel={onDismiss}
      titleText={t('components.ArchiveModal.title')}
      mounted={mounted}
      underlayClickExits={false}
      verticallyCenter
      focusTrapPaused
    >
      <h2>{t('components.FeeSchedulePage.ArchiveModal.title')}</h2>
      <p>{t('components.FeeSchedulePage.ArchiveModal.text')}</p>
      <div className="button-bar">
        <button
          className="button-link-appearance"
          disabled={isActive}
          onClick={onDismiss}
        >
          {t('common.cancel')}
        </button>
        <button
          className="button button-highlight"
          disabled={isActive}
          onClick={onConfirm}
        >
          {isActive
            ? t('components.FeeSchedulePage.ArchiveModal.archiving')
            : t('components.FeeSchedulePage.ArchiveModal.archive')}
        </button>
      </div>
    </Modal>
  );
};

ArchiveModal.defaultProps = {
  mounted: false,
  isActive: false,
};

ArchiveModal.propTypes = {
  className: PropTypes.string,
  mounted: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default ArchiveModal;
